module.exports = __webpack_public_path__ + "img/BASKET-547.d4056c67.png";